/** @format — Icons for chat input voice states */

export function MicrophoneIcon({ className = "w-6 h-6" }: { className?: string }) {
  return (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" className={className} aria-hidden>
      <path
        d="M14.25 5C14.25 4.40326 14.0128 3.83114 13.5908 3.40918C13.1689 2.98722 12.5967 2.75 12 2.75C11.4033 2.75 10.8311 2.98722 10.4092 3.40918C9.98722 3.83114 9.75 4.40326 9.75 5V12C9.75 12.5967 9.98722 13.1689 10.4092 13.5908C10.8311 14.0128 11.4033 14.25 12 14.25C12.5967 14.25 13.1689 14.0128 13.5908 13.5908C14.0128 13.1689 14.25 12.5967 14.25 12V5ZM15.75 12C15.75 12.9946 15.3546 13.9481 14.6514 14.6514C13.9481 15.3546 12.9946 15.75 12 15.75C11.0054 15.75 10.0519 15.3546 9.34863 14.6514C8.64537 13.9481 8.25 12.9946 8.25 12V5C8.25 4.00544 8.64537 3.05189 9.34863 2.34863C10.0519 1.64537 11.0054 1.25 12 1.25C12.9946 1.25 13.9481 1.64537 14.6514 2.34863C15.3546 3.05189 15.75 4.00544 15.75 5V12Z"
        fill="currentColor"
      />
      <path
        d="M4.25 12V10C4.25 9.58579 4.58579 9.25 5 9.25C5.41421 9.25 5.75 9.58579 5.75 10V12C5.75 13.6576 6.40895 15.2468 7.58105 16.4189C8.75316 17.591 10.3424 18.25 12 18.25C13.6576 18.25 15.2468 17.591 16.4189 16.4189C17.591 15.2468 18.25 13.6576 18.25 12V10C18.25 9.58579 18.5858 9.25 19 9.25C19.4142 9.25 19.75 9.58579 19.75 10V12C19.75 14.0554 18.9339 16.0271 17.4805 17.4805C16.0271 18.9339 14.0554 19.75 12 19.75C9.94457 19.75 7.97294 18.9339 6.51953 17.4805C5.06612 16.0271 4.25 14.0554 4.25 12Z"
        fill="currentColor"
      />
      <path
        d="M11.25 22V19C11.25 18.5858 11.5858 18.25 12 18.25C12.4142 18.25 12.75 18.5858 12.75 19V22C12.75 22.4142 12.4142 22.75 12 22.75C11.5858 22.75 11.25 22.4142 11.25 22Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function WaveformBarsIcon({ className = "w-6 h-6" }: { className?: string }) {
  return (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" className={className} aria-hidden>
      <rect x="3" y="10" width="2" height="4" rx="1" fill="currentColor" />
      <rect x="7" y="7" width="2" height="10" rx="1" fill="currentColor" />
      <rect x="11" y="4" width="2" height="16" rx="1" fill="currentColor" />
      <rect x="15" y="7" width="2" height="10" rx="1" fill="currentColor" />
      <rect x="19" y="10" width="2" height="4" rx="1" fill="currentColor" />
    </svg>
  );
}

export function StopSquareIcon({ className = "w-4 h-4" }: { className?: string }) {
  return (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" className={className} aria-hidden>
      <rect x="3" y="3" width="10" height="10" rx="1.5" fill="currentColor" />
    </svg>
  );
}

export function CloseIcon({ className = "w-4 h-4" }: { className?: string }) {
  return (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" className={className} aria-hidden>
      <path
        d="M4 4L12 12M12 4L4 12"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
}

export function CheckIcon({ className = "w-4 h-4" }: { className?: string }) {
  return (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" className={className} aria-hidden>
      <path
        d="M3.5 8.5L6.5 11.5L12.5 4.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function LoadingSunIcon({ className = "w-4 h-4" }: { className?: string }) {
  return (
    <svg
      width={16}
      height={16}
      viewBox="0 0 16 16"
      fill="none"
      className={`animate-spin ${className}`}
      aria-hidden
    >
      <path
        d="M8 1.5V3.5M8 12.5V14.5M14.5 8H12.5M3.5 8H1.5M12.364 3.636L10.95 5.05M5.05 10.95L3.636 12.364M12.364 12.364L10.95 10.95M5.05 5.05L3.636 3.636"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
}
